// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3221":"css/app.7001","9259":"css/admin-app.7001"}[chunkId] + ".css";
};